<form #f="ngForm">
    <div class="p-as-center p-mt-auto">
        <div class="p-grid">
            <div class="p-col-12">        
                <div class="p-col-12 error-notify-text">
                    <app-validateform #loginForm [formToValidate]="loginFormValidate"></app-validateform>
                </div>
            </div>
        </div>
    </div>
    <div class="p-d-flex p-flex-column">
        <div class="p-as-center p-mt-auto">
            <div class="login-page pages-panel card">
                <div class="input-panel">
                    <div class="p-ml-3 p-mr-3">
                        <div class="p-mb-4 p-mt-3" style="text-align:center !important"><h4>Login to your account</h4></div>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-envelope"></i>
                            </span>
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="username"
                                       name="username"
                                       requiredNoSpaceValidator
                                       data-display-name="Email" />
                                <label for="inputgroup">Email*</label>
                            </span>
                        </div>
                        <div class="p-inputgroup p-mt-3 p-mb-6">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-lock"></i>
                            </span>
                            <span class="p-float-label">
                                <p-password id="inputgroup"
                                            [(ngModel)]="password"
                                            [toggleMask]="true"
                                            name="Password"
                                            data-display-name="Password"
                                            [feedback]="false"
                                            (keyup.enter)="Login()">
                                </p-password>
                                <label for="inputgroup">Password</label>
                            </span>
                        </div>
                        <button pButton (click)="Login()" class="fullwidthbtn p-mb-2" label="LOGIN"></button>
                        <p-button class="p-mb-2" label="(Forgot your password?)" styleClass="p-button-link" routerLink="/forgotpassword"></p-button>
                        <div class="p-mb-4">
                            By logging into this application you agree to our
                            <p-button label="Terms of Service" styleClass="p-button-link" (click)="ShowPolicy(1)"></p-button> and
                            <p-button label="Privacy Policy" styleClass="p-button-link" (click)="ShowPolicy(2)"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
